<template>
	<router-view></router-view>
</template>

<script>
	export default {
		created() {
			//在页面加载时读取localStorage里的状态信息
			// if (localStorage.getItem("store")) {
			// 	this.$store.replaceState(
			// 		Object.assign({},
			// 			this.$store.state,
			// 			JSON.parse(localStorage.getItem("store"))
			// 		)
			// 	);
			// }
			// //在页面刷新时将vuex里的信息保存到localStorage里
			// window.addEventListener("beforeunload", () => {
			// 	localStorage.setItem("store", "");
			// 	localStorage.setItem("store", JSON.stringify(this.$store.state));
			// });

			//禁用Ctrl+C
			document.onkeydown = function(e) {
				var ev = document.all ? window.event : e;
				if ((ev.ctrlKey) && (ev.keyCode == 67)) {
					ev.returnValue = false;
					ev.preventDefault();
					return false;
				} else if ((ev.ctrlKey) && (ev.keyCode == 86)) {
					ev.returnValue = false;
					ev.preventDefault();
					return false;
				} else if (ev.keyCode == 123) {
					return false;
				}
			}

			// 禁用右键菜单
			document.oncontextmenu = function() {
				return false;
			}
		}
	}
</script>


<style>
	html,
	body {
		margin: 0;
		padding: 0;
		height: 100%;
		font-family: helvetica, "microsoft yahei", 微软雅黑, arial, sans-serif, 'Hiragino Sans GB';
		color: ##061b36;
		overflow: hidden;
	}
</style>